import { assocPath, has, prop, propOr } from 'ramda';
import { ConfigElement } from '@components-fabric/types';
import { getTableSource } from '../utils/get-table-source';
import { normalizePath } from '../../../packages/core/toolbox/objects';
import { processColumns } from '../../../components-common/tables/columns/_builder';
import { RootieTable } from '../../../components-common/tables/RootieTable';

export const mapTable = (
  obj: ConfigElement,
  context: any,
  type: string = 'viewer'
) => {
  let result = {
    id: `tbl_${propOr('NOT_SET', 'id', obj)}`,
    cat: 'table',
    type,
    Component: propOr(RootieTable, 'tableComponent', obj),
    props: {
      source: getTableSource(obj),
    },
  };
  if (has('columns', obj) || has('empty', obj)) {
    result = assocPath(
      normalizePath('props.columns'),
      processColumns(
        prop('columns' as any, obj) as any,
        prop('empty', obj as any)
      ),
      result
    );
  }

  if (has('actions', obj)) {
    result = assocPath(
      normalizePath('props.actions'),
      prop('actions', obj) as any[],
      result
    );
  }
  if (has('urlParams', obj)) {
    result = assocPath(
      normalizePath('props.source.urlParams'),
      prop('urlParams', obj),
      result
    );
  }

  return result;
};
